import { render, staticRenderFns } from "./AscMxStatusLabel.vue?vue&type=template&id=7e4dc024&"
import script from "./AscMxStatusLabel.vue?vue&type=script&lang=js&"
export * from "./AscMxStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports